import { render } from "./SubCategoriesPage.vue?vue&type=template&id=571da102"
import script from "./SubCategoriesPage.vue?vue&type=script&lang=js"
export * from "./SubCategoriesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__